function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BackupTemplate = require('./backup.template');
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoLoader = require('./../../../lib/saito/ui/saito-loader/saito-loader');
var Backup = /*#__PURE__*/function () {
  function Backup(app, mod) {
    _classCallCheck(this, Backup);
    this.app = app;
    this.mod = mod;
    this.success_callback = null;
    this.modal_overlay = new SaitoOverlay(this.app, this.mod);
    this.loader = new SaitoLoader(this.app, this.mod, '#backup-template #saito-overlay-loader');
  }
  return _createClass(Backup, [{
    key: "render",
    value: function render() {
      var _this = this;
      if (!document.getElementById('backup-template')) {
        this.modal_overlay.show(BackupTemplate());
        this.modal_overlay.callback_on_close = function () {
          var _this$app$options$wal;
          if ((_this$app$options$wal = _this.app.options.wallet) !== null && _this$app$options$wal !== void 0 && _this$app$options$wal.backup_required) {
            _this.app.connection.emit('saito-header-update-message', {
              msg: 'wallet backup needed',
              flash: true,
              callback: function callback() {
                _this.app.connection.emit('recovery-backup-overlay-render-request');
              }
            });
          }
        };
      } else {
        this.app.browser.replaceElementById(BackupTemplate(), 'backup-template');
      }
      this.attachEvents();
    }
  }, {
    key: "show",
    value: function show() {
      this.render();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.close();
    }
  }, {
    key: "close",
    value: function close() {
      this.modal_overlay.close();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var this_self = this;
      document.querySelector('#backup-template .saito-overlay-form-submit').onclick = function (e) {
        e.preventDefault();
        var email = document.querySelector('#backup-template .saito-overlay-form-email').value;
        var password = document.querySelector('#backup-template .saito-overlay-form-password').value;
        if (!email || !password) {
          salert('No email or password provided!');
          return;
        }
        this_self.showLoaderOverlay();
        this_self.mod.backupWallet({
          email: email,
          password: password
        });
      };
      document.querySelector('#saito-backup-manual').addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this_self.app.wallet.backupWallet();
            case 1:
              _context.n = 2;
              return this_self.success();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      })));
    }

    //
    // This is called when we receive the backup wallet tx that we sent
    //
  }, {
    key: "success",
    value: function success() {
      siteMessage('wallet backup successful', 5000);
      delete this.app.options.wallet.backup_required;
      if (this.success_callback) {
        this.success_callback();
      }
      this.modal_overlay.remove();
    }
  }, {
    key: "showLoaderOverlay",
    value: function showLoaderOverlay() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      document.querySelector('#saito-overlay-form-header-title').innerHTML = "Enabling Account Recovery";
      var div = document.querySelector('#backup-template .saito-overlay-subform');
      if (div) {
        if (msg == null) {
          msg = "\n\t\t\t\t\t<div id=\"saito-overlay-loader\"></div>\n\t\t\t\t\t<div class=\"saito-overlay-form-subtext\">\n\t\t\t\t\t    Your browser is encrypting your wallet with the password \n\t\t\t\t\t    provided. Once completed, it will send a copy of this \n\t\t\t\t\t    wallet to your email address.\n\t\t            </div>\n\n\t\t\t\t\t<div class=\"saito-overlay-form-subtext\">\n\t\t\t\t\t\tThis entire process usually takes no more than a minute. \n\t\t\t\t\t\tOnce done you will also be able to login to your account \n\t\t\t\t\t\tfrom any computer. Please be patient while the process finishes.\n\t\t      \t\t</div>\n\t      \t\t";
        }
        div.innerHTML = msg;
        div.classList.add('centered');
      }
      this.loader.render();
      var button = document.querySelector('#backup-template .saito-overlay-form-submit');
      if (button) {
        button.innerHTML = 'Uploading...';
        button.onclick = null;
      }
    }
  }]);
}();
module.exports = Backup;